import { render, staticRenderFns } from "./select_code.vue?vue&type=template&id=640dfedd&scoped=true&"
import script from "./select_code.vue?vue&type=script&lang=js&"
export * from "./select_code.vue?vue&type=script&lang=js&"
import style0 from "./select_code.vue?vue&type=style&index=0&id=640dfedd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640dfedd",
  null
  
)

export default component.exports